// GENERATED FILE - DO NOT MODIFY
import { ContactLookupModel } from "api/models/company/contact/contact-lookup-model";
import { ContactModel } from "api/models/company/contact/contact-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class DispatchContactProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetDispatchContact(dispatchId: number, requestConfig?: HttpClientRequestConfig): Promise<ContactModel | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/contact",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            null
        );

        const data: ContactModel | null = await this.get<ContactModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactModel");
        return data;
    }

    public async GetDispatchContactLookup(dispatchId: number, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/contact/lookup",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            null
        );

        const data: ContactLookupModel | null = await this.get<ContactLookupModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }

    public async GetContactsForDispatchClient(dispatchId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactModel[] | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/clientcontacts",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactModel[] | null = await this.get<ContactModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactModel");
        return data;
    }

    public async GetContactsLookupForDispatchClient(dispatchId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel[] | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/clientcontacts/lookup",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactLookupModel[] | null = await this.get<ContactLookupModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }

    public async GetCustomerSiteContactsLookupForDispatchClient(dispatchId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel[] | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/customer-site-contacts/lookup",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactLookupModel[] | null = await this.get<ContactLookupModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }
}
